import { IconWrapper, ISvgIconProps } from '.';

export default IconWrapper('down-one', true, (props: ISvgIconProps) => (
  <svg width={props.size} height={props.size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M36 19L24 31L12 19H36Z"
      stroke={props.colors[0]}
      fill={props.colors[0]}
      strokeWidth={props.strokeWidth}
      strokeLinecap={props.strokeLinecap}
      strokeLinejoin={props.strokeLinejoin}
    />
  </svg>
));
